import React, { createContext, useContext, useCallback, ReactNode } from 'react';

import { useTranslation as useTranslationHook } from 'react-i18next';

interface useTranslationContextProps {
  onTranslation: (nameObject: string) => string;
}

interface useTranslationProviderProps {
  children: ReactNode;
}

const useTranslationContext = createContext({} as useTranslationContextProps);

const UseTranslationProvider : React.FC<useTranslationProviderProps> = ({children}: useTranslationProviderProps) => {
  const [t] = useTranslationHook('common');

  const onTranslation = useCallback((nameString: string) => {
    return t(nameString); 
  }, [t]);
  
  return (
    <useTranslationContext.Provider value={{ onTranslation }}>
      {children}
    </useTranslationContext.Provider>
  );
}

function useTranslation(): useTranslationContextProps {
  const context = useContext(useTranslationContext);

  if (!context) {
    throw new Error(
      'FilterProductContext must be used within a useFilterProduct',
    );
  }

  return context;
}

export { UseTranslationProvider, useTranslation };
